<template>
	<!-- 產品目錄 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>產品目錄</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 我的產品 -->
		<div class="deal_content_box">
			<div class="deal_content_title">我的產品</div>
			<div class="deal_content div_hight">
				<div class="div_left_red">支付產品</div>
				<div class="bock_div">
					<el-row>
						<el-col :span="10">
							<img src="../../../../assets/img/user/01my_product.png" alt="">
						</el-col>
						<el-col :span="14">
							<h2 class="title-h2">API支付</h2>
							<span>商戶調用API界面，調起台易購支付模組收款</span>
						</el-col>
					</el-row>
				</div>
				<div class="div_left_red">資金解決方案</div>
				<div class="bock_div_end">
					<el-row>
						<el-col :span="10">
							<img src="../../../../assets/img/user/02my_product.png" alt="">
						</el-col>
						<el-col :span="14">
							<h2 class="title-h2">API支付</h2>
							<span>商戶調用API界面，調起台易購支付模組收款</span>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>

	</div>



</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
			return {
				uid: '',
				name: '',
				tel: '',
				joindate: '',
				mailbox: '',
				reserved: '',
				starttime: ''
			}
		},
		methods: {

		},
		mounted() {

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 交易管理》交易订单 */
	.deal_index_box {
		margin: 30px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 100px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}

	/* 表单 */
	.table_download {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.table_download span {
		display: inline-block;
		margin: 0 10px;
	}

	/* 表单头 */
	.table_header {
		height: 36px;
		line-height: 36px;
		background: #f2f2f2;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_content {
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_date {
		box-sizing: border-box;
		width: 160px;
		padding-left: 14px;
		padding-right: 10px;
	}

	.table_merchantorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymentorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		min-width: 160px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymenttype {
		box-sizing: border-box;
		width: 98px;
		padding: 0 10px;
		min-width: 77px;
	}

	.table_status {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	.table_money {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	/* .table_content .table_money {
        text-align: right;
    } */
	.table_operation {
		padding: 0 10px;
	}

	.table_operation span {
		margin-right: 10px;
		padding-bottom: 2px;
		border-bottom: 1px solid;
	}

	/* 分页 */
	.table_pagination {
		display: flex;
		margin: 20px;
		justify-content: flex-end;
	}

	/* 个人资讯 */
	.list_high {
		color: #666666;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
	}

	.font_high {
		color: darkgrey;
		display: flex;
		height: 36px;
		line-height: 36px;
		font-size: 11px;
		text-indent: 6em;
	}

	.div_hight {
		padding-top: 10px;
	}



	.div_hight_end {
		padding-top: 10px;

	}

	.div_left_red {
		border-left: 10px solid #E73262;
		margin: 20px 40px;
		font-size: 17px;
		padding-left: 10px;
	}

	.title-h2 {
		font-size: 19px;
		font-weight: 700;
		padding-bottom: 10px;
	}

	.bock_div,
	.bock_div_end {
		height: 80px;
		width: 270px;
		border: 1px solid #777777;
		margin-left: 40px;
		padding: 15px;
		font-size: 11px;
	}

	.bock_div_end {
		margin-bottom: 50px;
	}
</style>
